import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const YearContext = createContext(null);

export const YearProvider = ({ children }) => {
  const [year, setYear] = useState(2027);
  const [years, setYears] = useState([2027]);

  const refreshYears = useCallback(async () => {
    try {
      const { data } = await api.get("/years");
      setYears(data);
    } catch (e) { /* ignore */ }
  }, []);

  useEffect(() => { refreshYears(); }, [refreshYears]);

  const addYear = (y) => setYears((prev) => (prev.includes(y) ? prev : [...prev, y].sort()));

  return (
    <YearContext.Provider value={{ year, setYear, years, addYear, refreshYears }}>
      {children}
    </YearContext.Provider>
  );
};

export const useYear = () => useContext(YearContext);
